import type { EventType } from "@/global/store/data/types";
import { CSSProperties } from "react";
import { UpcomingEventCard } from "./UpcomingEventCard";
import { FeaturedEventCard } from "./FeaturedEventCard";
import { SxProps } from "@mui/material";
import { AnimatedCardProps } from "@/shared/base/components/AnimatedCard/AnimatedCard";

export interface EventCardProps {
  cardVariant?: AnimatedCardProps["variant"];
  event: EventType;
  isSelected?: boolean;
  isDisabled?: boolean;
  isInvPreviewButtonHidden?: boolean;
  onSelect?: () => void;
  onClickPreview?: () => void;
  variant: "upcoming" | "featured" | "common";
  slot?: {
    wrapper?: {
      style?: CSSProperties;
    };
  };
}

export function CombinedEventCard(props: EventCardProps) {
  if (props?.variant === "upcoming") {
    return <UpcomingEventCard {...props} />;
  } else if (props?.variant === "featured") {
    return <FeaturedEventCard {...props} />;
  } else {
    return <UpcomingEventCard {...props} />;
  }
}
